import cloneDeep from 'lodash/cloneDeep';

import type { QuestionGroupModel } from '@webapp/common/resources/entities';
import { initialQuestionGroup } from '@webapp/common/resources/entities';

import type { QuestionResponseEntity } from './question-response';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface QuestionGroupEntity extends QuestionGroupModel {}

export class QuestionGroupEntity {
    public responses: Map<number, QuestionResponseEntity> = new Map();

    constructor(initial: QuestionGroupModel /*, questionType: QuestionType*/) {
        for (const [k, v] of Object.entries({ ...cloneDeep(initialQuestionGroup), ...initial })) {
            this[k] = v;
        }
    }
}
